import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ConstantsService, SessionService, RequestTypesEnum, EnvironmentService, LookupsService } from '@app/base/core';
import { triggerFormValidation, focusFirstInvalidField } from '@app/base/shared';
import {AlertService} from '@app/base/alerts/alert.service';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  requestStatusForm: FormGroup;
  alertMsg: any = [];
  typesEnum: typeof RequestTypesEnum = RequestTypesEnum;

  constructor(
    public sessionSvc: SessionService,
    public environmentSvc: EnvironmentService,
    private alertService: AlertService,
    private constantsSvc: ConstantsService, public lookupSvc: LookupsService,
    private router: Router,
    ) {
          }
  get requestId()  { return (this.requestStatusForm.get('requestId').value);
 }

  ngOnInit() {
    // closes any modal popup if opened
    if ($('.swal-modal').is(':visible')) {
      swal.close();
    }
    if ($('#soco-modal').is(':visible')) {
      $('#soco-modal').modal('hide');
    }
    // Load common lookup values
    const subscribe = this.lookupSvc.commonLookupsLoaded$.subscribe(val => {
      if (subscribe && val) {
        subscribe.unsubscribe();
      }
      // Banner message for Home page
      if (val) {
         this.alertMsg = (this.lookupSvc.bannerMessages.find( x => x.itemName === 'Home'
      ));
        this.alertService.info(this.alertMsg.message);
      }
    });
    // init request status form
      this.requestStatusForm = new FormGroup({
      requestId: new FormControl('', [Validators.required, Validators.pattern(this.constantsSvc.numericPattern)])
    });
  }
  // Navigation to status page on form submit
  submitForm() {
    if (this.requestStatusForm.valid) {
      this.router.navigate(['/', this.sessionSvc.paramLdc.toLocaleLowerCase(), 'status', this.requestId]);
    } else {
       triggerFormValidation(this.requestStatusForm);
      focusFirstInvalidField(this.requestStatusForm);
    }
  }
}
